import type { Page } from '../../types';

const departmentSelect: Page[] = [
  {
    pageType: 'question',
    title: 'Department Select',
    name: 'department-select',
    questions: [
      {
        questionType: 'select',
        title: 'Please select the department you are reporting for',
        name: 'department',
        hintOption: 'Please Select',
        options: {
          source: 'athenaPageLoad',
          lookupType: 'psfaDepartmentList',
          valueField: 'dept_name',
          derivedFields: {
            department_id: 'dept_id',
          },
          maxRows: 1000,
          environment: 'auto',
        },
        rules: { required: true },
      },
      {
        questionType: 'select',
        title: 'Please select your organisation',
        name: 'sub_organisation',
        hintOption: 'Please Select',
        options: {
          source: 'athenaPageLoad',
          lookupType: 'psfaDepartmentList',
          valueField: 'org_name',
          filterBy: {
            answerField: 'department',
            lookupField: 'dept_name',
          },
          derivedFields: {
            organisation_id: 'org_id',
          },
          maxRows: 1000,
          environment: 'auto',
        },
        rules: { required: true },
      },
      {
        questionType: 'hidden',
        title: 'Department ID',
        name: 'department_id',
      },
      {
        questionType: 'hidden',
        title: 'Organisation ID',
        name: 'organisation_id',
      },
      {
        questionType: 'reportPeriod',
        title: 'Period of Report',
        name: 'report-period',
        defaultValue: 'auto',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Name of person completing this form',
        name: 'submitter_name',
        hint: 'Person responsible for completing form to whom questions can be addressed',
        rules: { required: true },
      },
      {
        questionType: 'textInput',
        title: 'Email of person completing this form',
        name: 'submitter_email',
        rules: { required: true, email: true },
      },
      {
        questionType: 'textInput',
        title: 'Name of Senior Officer responsible for Counter Fraud',
        name: 'senior_officer_name',
        rules: { required: true },
      },
      {
        questionType: 'textInput',
        title: 'Email of Senior Officer responsible for Counter Fraud',
        name: 'senior_officer_email',
        rules: { required: true, email: true },
      },
      {
        questionType: 'textInput',
        title: 'Name of Board member accountable for counter fraud',
        name: 'board_member_name',
        rules: { required: false },
      },
      {
        questionType: 'textInput',
        title: 'Email of Board member accountable for counter fraud',
        name: 'board_member_email',
        rules: { required: false, email: true },
      },
    ],
  },
];

export default departmentSelect;

